import useMediaQuery from '@mui/material/useMediaQuery';

// Matches Bootstrap's `md` boundary; keep in sync with the literal in boot/mobile.scss.
export const PHONE_MEDIA_QUERY = '(max-width: 767.98px)';
export const CAN_HOVER_MEDIA_QUERY = '(hover: hover)';

// noSsr reads the real value on the first render, so mount-only props (e.g. FullCalendar's initialView) get it.
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_MEDIA_QUERY, { noSsr: true });
}

export function useCanHover(): boolean {
  return useMediaQuery(CAN_HOVER_MEDIA_QUERY, { noSsr: true });
}
